<template>
  <div class="pop-box">
    <div class="pop-title">{{ $t('share') }}</div>
    <div class="share-link">{{ $t('add.text80') }}</div>
    <CopyBox :copyText="sharePath" />
    <div class="share-link" style="margin-top: 0.2rem">
      {{ $t('activitypage.text12') }}
    </div>
    <ShareBox :sharePath="sharePath" />
    <el-button
      class="el-button--white block"
      style="margin-top: 0.25rem"
      @click="handleCancel"
      >{{ $t('cancel') }}</el-button
    >
  </div>
</template>
<script>
import CopyBox from '@/components/CopyBox.vue'
import ShareBox from '@/components/ShareBox.vue'

export default {
  components: {
    ShareBox,
    CopyBox
  },
  props: {
    sharePath: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  methods: {
    handleCancel() {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SharePop.vue